import styled from "styled-components";

export const MypageWrapper = styled.div`
  padding: 0 16px;
  box-sizing: border-box;
`;

export const Head = styled.div`
  position: relative;
  padding: 9px 0;
  text-align: center;

  & a {
    height: 24px;
  }

  & img {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    left: 13px;
  }

  & h1 {
    font-weight: 700;
    font-size: 1.125rem;
    text-align: center;
  }
`;

export const EachContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  margin: 5px 0px;
  color: #222529;
  font-size: 16px;
  font-weight: bold;
`;


